var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareGradient({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4314_138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 20C22.9857 20 22.0602 20.3783 21.3551 21.0005L7.9864 14.3161C7.9946 14.2117 8.00002 14.1065 8.00002 14C8.00002 13.8935 7.9946 13.7883 7.9864 13.6839L21.3551 6.99962C22.0602 7.62174 22.9857 8.00002 24 8.00002C26.2091 8.00002 28 6.20911 28 4.00001C28 1.79091 26.2091 0 24 0C21.7909 0 20 1.79091 20 4.00001C20 4.10648 20.0054 4.2117 20.0136 4.3161L6.64491 11.0005C5.93983 10.3783 5.0143 9.99999 4.00001 9.99999C1.79091 9.99999 0 11.7909 0 14C0 16.2091 1.79091 18 4.00001 18C5.0143 18 5.93983 17.6217 6.64491 16.9995L20.0136 23.6838C20.0054 23.7883 20 23.8935 20 24C20 26.2091 21.7909 28 24 28C26.2091 28 28 26.2091 28 24C28 21.7909 26.2091 20 24 20Z",
    fill: "url(#paint0_linear_4314_138)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4314_138",
    x1: -4.70556,
    y1: 58.1,
    x2: -31.076,
    y2: 35.8609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4314_138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareGradient);
export default __webpack_public_path__ + "static/media/share_gradient.191b6b7df07b262d3c3661d2226c3bba.svg";
export { ForwardRef as ReactComponent };